<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-reset`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.96878 1.63916C11.4813 1.63918 14.3289 4.487 14.3291 7.99951C14.3291 11.5122 11.4815 14.3598 7.96878 14.3599C6.306 14.3599 4.79102 13.7208 3.65823 12.6763C3.38845 12.4273 3.37124 12.0067 3.62014 11.7368C3.86909 11.4671 4.28967 11.45 4.5596 11.6987C5.45645 12.5257 6.65305 13.0298 7.96878 13.0298C10.7469 13.0298 12.9991 10.7777 12.9991 7.99951C12.9988 5.22154 10.7468 2.96926 7.96878 2.96924C5.54909 2.96925 3.52905 4.67817 3.04788 6.95459L3.86331 6.34229C4.15681 6.12179 4.57427 6.18084 4.79495 6.47412C5.01554 6.76775 4.95673 7.18614 4.66311 7.40674L2.67092 8.90186C2.37738 9.12236 1.9609 9.06342 1.74026 8.77002L0.24319 6.77881C0.0226955 6.4852 0.0824633 6.06776 0.376003 5.84717C0.669559 5.62704 1.08616 5.68567 1.30667 5.979L1.76663 6.59033C2.40806 3.75612 4.9406 1.63917 7.96878 1.63916Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineReset',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
